module.exports = __webpack_public_path__ + "static/media/loginLogo.1317b086.png";